import { InjectionToken, Signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface ToastItem {
  id: number;
  type: ToastType;
  title: string;
  message: string;
  duration: number;
}

export interface ToastState {
  toasts: Signal<ToastItem[]>;
  remove: (id: number) => void;
}

export const TOAST_STATE = new InjectionToken<ToastState>('TOAST_STATE');
